import { getAssignedDataGroup } from "../../../../../core/router/auth";
import { ResourceName } from "../../../../../core/router/config/ResourceName";
import { baseAuthApi } from "../../../../../core/service/baseApi";
import type { FormMutation } from "../../../../../core/service/types/FormMutation";
import type { FormQuery } from "../../../../../core/service/types/FormQuery";
import type { Dto } from "../../../../../core/types/be/Dto";
import type { HostProductCodeEntity } from "../../types/HostProductCodeEntity";
import { HostProductCodeDtoToEntity } from "../mappers/HostProductCodeDtoToEntity";
import { HostProductCodeEntityToDto } from "../mappers/HostProductCodeEntityToDto";

const HostProductCodeApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        HostProductCodeLoad: builder.query<HostProductCodeEntity, FormQuery>({
            providesTags: [ResourceName.HOST_PRODUCT_CODES],
            query: (queryParams) => {
                const dataGroup = getAssignedDataGroup();
                return {
                    url: `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.HOST_PRODUCT_CODES}/${queryParams.entityId}`,
                    method: "GET",
                };
            },
            transformResponse: (response: Dto, _) => {
                return HostProductCodeDtoToEntity(response);
            },
        }),
        HostProductCodeSave: builder.mutation<HostProductCodeEntity, FormMutation<HostProductCodeEntity>>({
            query: (mutation) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.HOST_PRODUCT_CODES}`;
                const method = "POST";

                const body = HostProductCodeEntityToDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.HOST_PRODUCT_CODES],
        }),
        HostProductCodeUpdate: builder.mutation<HostProductCodeEntity, FormMutation<HostProductCodeEntity>>({
            query: (mutation) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.HOST_PRODUCT_CODES}/${mutation.data.id}`;
                const method = "PUT";

                const body = HostProductCodeEntityToDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.HOST_PRODUCT_CODES],
        }),
    }),
});

export const { useHostProductCodeLoadQuery, useHostProductCodeSaveMutation, useHostProductCodeUpdateMutation } = HostProductCodeApi;
